import { useContext } from 'react'
import {
  BreadcrumbsContext,
  BreadcrumbsContextType,
} from '@context/BreadCrumbContext/index'

const useBreadcrumb = (): BreadcrumbsContextType =>
  useContext(BreadcrumbsContext)

export default useBreadcrumb
